import * as StationConstants from './constants';
import * as D from './deps';

export function setEditMode(editMode) {
  return {
    type: StationConstants.actions.TOGGLE_EDIT_MODE,
    data: { editMode },
  };
}

export function loadStations({
  listenerId,
  sortBy,
  sortAscending,
  pageSize,
  startIndex,
  startsWith,
} = {}) {
  return {
    type: StationConstants.actions.LOAD_STATIONS,
    data: {
      listenerId,
      pageSize,
      sortAscending,
      sortBy,
      startIndex,
      startsWith,
    },
  };
}

export function createStation({ pandoraId }) {
  return {
    type: D.Constants.Playback.ActionTypes.CREATE_STATION,
    data: {
      pandoraId,
    },
  };
}

export function routeToStationDetailsFromFactoryId({ pandoraId }) {
  return {
    type: D.Constants.Playback.ActionTypes.ROUTE_TO_STATION_DETAILS_FROM_FACTORY_ID,
    data: {
      pandoraId,
    },
  };
}

export function getStationFeedback({ pageSize, startIndex, stationId, positive, mostRecent }) {
  return {
    type: StationConstants.actions.GET_STATION_FEEDBACK,
    data: {
      mostRecent,
      pageSize,
      positive,
      startIndex,
      stationId,
    },
  };
}

/**
 * Action creator triggered by opening narratives
 *
 * @returns {object} - Standard action
 */
export function showStationNarrative() {
  return {
    type: D.Constants.Playback.ActionTypes.IS_STATION_NARRATIVE_DISPLAYED,
    data: {
      doShow: true,
    },
  };
}

/**
 * Action creator triggered by closing narratives
 *
 * @param {string} stationId - This param is provided if the user wishes to stop station narratives for a station
 * @returns {object} - Standard action
 */
export function hideStationNarrative(stationId) {
  return {
    type: D.Constants.Playback.ActionTypes.IS_STATION_NARRATIVE_DISPLAYED,
    data: {
      doShow: false,
      stationId,
    },
  };
}

export function setInteractiveRadioMode({ stationId, modeId, previousModeId }) {
  return {
    type: StationConstants.actions.SET_INTERACTIVE_RADIO_MODE,
    data: {
      stationId,
      modeId,
      previousModeId,
    },
  };
}

export function fetchInteractiveRadioModes({ stationId }) {
  return {
    type: StationConstants.actions.FETCH_INTERACTIVE_RADIO_MODES,
    data: {
      stationId,
    },
  };
}

export function setShouldShortCircuitAfterGetFragment(shouldShortCircuitAfterGetFragment) {
  return {
    type: StationConstants.actions.SET_SHOULD_SHORT_CIRCUIT_AFTER_GET_FRAGMENT,
    data: {
      shouldShortCircuitAfterGetFragment,
    },
  };
}

export function handleStartStationError({ pandoraId, error, errorRecoveryPath }) {
  return {
    type: StationConstants.actions.HANDLE_START_STATION_ERROR,
    data: {
      pandoraId,
      error,
      errorRecoveryPath,
    },
  };
}

export function loadPrefetchedTracks({ stationId }) {
  return {
    type: D.PlaybackConstants.ActionKeys.LOAD_PREFETCHED_TRACKS,
    data: {
      stationId,
    },
  };
}
